import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'inventory',
    permissionsPrefix: 'inventory',
    displayName: 'Inventory',

    navSections: [
        { key: 'dashboard',     label: 'Dashboard',     route: '/inventory/dashboard' },
        { key: 'transactions',  label: 'Transactions',  route: '/inventory/transactions' },
        { key: 'reports',       label: 'Reports',       route: '/inventory/reports' },
        { key: 'configuration', label: 'Configuration', route: '/inventory/configuration' },
        { key: 'maintenance',   label: 'Maintenance',   route: '/inventory/maintenance' },
    ],

    resources: [
        { key: 'stockTransactions', label: 'Stock transactions',  navSection: 'transactions' },
        { key: 'stockTransactionPosting', label: 'Stock transactions — unpost', navSection: 'transactions' },
        { key: 'gateOutwardPosting',      label: 'Gate outward — unpost',       navSection: 'transactions' },
        { key: 'jobCardIssuancePosting',  label: 'Job card issuance — unpost',  navSection: 'transactions' },
        { key: 'stockIssuance',     label: 'Stock issuance',      navSection: 'transactions' },
        { key: 'stockReturn',       label: 'Stock return',        navSection: 'transactions' },
        { key: 'goodsReceipt',      label: 'Goods receipt',       navSection: 'transactions' },
        { key: 'gateOutward',       label: 'Gate Outward',        navSection: 'transactions' },
        { key: 'jobCardIssuance',   label: 'Job card issuance',   navSection: 'transactions' },
        { key: 'itemStockReport',   label: 'Item stock report',   navSection: 'reports' },
        { key: 'stockMovementBySourceReport', label: 'Stock movement by source report', navSection: 'reports' },
        { key: 'inventWarehouses',  label: 'Warehouses',          navSection: 'configuration' },
        { key: 'productProfiles',   label: 'Product profiles',    navSection: 'configuration' },
        { key: 'productCategories', label: 'Product categories',  navSection: 'configuration' },
        { key: 'stockPatch',        label: 'Stock patch',         navSection: 'maintenance' },
    ],
    // Note: 'deliveryOrders' is intentionally NOT listed here — it's owned by Sales
    // (permissionsPrefix 'sales') since the backend only checks sales.deliveryOrders.*
    // permissions. It's mounted read/write in InventoryWorkspace.tsx too (same resource,
    // same data), gated by that same sales.deliveryOrders.* permission via a second
    // useResourcePermissionGate('sales') instance, so there's exactly one permission to grant.
} satisfies WorkspaceAppManifest;
